<app-homepage-spinner *ngIf="loading"></app-homepage-spinner>

<div *ngIf="!loading">
  <div>
    <app-home-banner></app-home-banner>
  </div>
  <!-- <app-loading *ngIf="loading"></app-loading> -->

  <!--Limited Time Deal Section-->
  <!-- <div class="container mt-5">
    <app-limited-time-deals [data]="limited_time"></app-limited-time-deals>
  </div> -->

  <!--New Release Categories-->
  <div class="container mt-5">
    <app-product-list
      [data]="new_release"
      [title]="'New Release'"
    ></app-product-list>
  </div>

  <!--Most Viewed Categories-->
  <div class="container mt-5">
    <app-product-list
      [data]="most_viewed"
      [title]="'Most Viewed'"
    ></app-product-list>
  </div>
  <!--Recommended For You Section-->
  <div class="container mt-5">
    <app-product-list
      [data]="recommended"
      [title]="'Recommended For You'"
    ></app-product-list>
  </div>

  <!--Best Sellers Categories-->
  <div class="container mt-5">
    <app-product-list
      [data]="best_sellers"
      [title]="'Best Sellers'"
      [bstCheck]="true"
    ></app-product-list>
  </div>

  <!--Top Rated Categories-->
  <div class="container mt-5">
    <app-product-list
      [data]="top_rated"
      [title]="'Top Rated'"
    ></app-product-list>
  </div>

  <!--Newsletter Section-->
  <section class="_nLttr mt-5">
    <div class="container">
      <app-home-newsletter-section></app-home-newsletter-section>
    </div>
  </section>
</div>
